const themes = {
  OPTUM: 'optum',
  UHC: 'uhc',
  UHG: 'uhg',
}

export default themes
